import { buildChartTheme } from '@visx/xychart';

export const customTheme = buildChartTheme({
  colors: ['#E30303', '#00FFCB', '#0A76AE'],
  backgroundColor: '#ebebeb',
  tickLength: 6,
  gridColor: '#ccc',
  gridColorDark: '#ccc',
});
